import create, { SetState } from 'zustand';
import { UpdateBaseQueryState } from './interfaces/UpdateQueryState';
import { createCommonBaseQuerySlice } from './slices/BaseQuerySlices/CommonBaseQuerySlice';
import { createUpdateBaseQuerySlice } from './slices/BaseQuerySlices/UpdateBaseQuerySlice';

export const useUpdateBaseQueryStore = create((set: SetState<UpdateBaseQueryState>) => ({
  ...createUpdateBaseQuerySlice(set),
  ...createCommonBaseQuerySlice(set)
}));
